import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import productReducer from './slices/product-slice';
import currencyReducer from "./slices/currency-slice";
import cartReducer from "./slices/cart-slice";
import newCartReducer from "./slices/newCart-slice";
import compareReducer from "./slices/compare-slice";
import wishlistReducer from "./slices/wishlist-slice";
import authReducer from "./slices/auth-slice";
import profileReducer from "./slices/profile-slice";
import homeReducer from "./slices/home-slice";
import shopReducer from "./slices/shop-slice";
import orderHistoryReucer from './slices/orderHistory-slice';
import tenantReducer from './slices/tenant-slice';
const persistConfig = {
    key: "CAIA",
    version: 1.1,
    storage,
};

export const rootReducer = combineReducers({
    product: productReducer,
    currency: currencyReducer,
    cart: cartReducer,
    newCart: newCartReducer,
    compare: compareReducer,
    wishlist: wishlistReducer,
    auth: authReducer,
    profile: profileReducer,
    home: homeReducer,
    shop: shopReducer,
    orderHistory: orderHistoryReucer,
    tenant: tenantReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER,
                ],
            },
        }),
});

export const persistor = persistStore(store);
